import { render } from "./NeobuqCarbonForm.vue?vue&type=template&id=2d0f6a15&scoped=true"
import script from "./NeobuqCarbonForm.vue?vue&type=script&lang=js"
export * from "./NeobuqCarbonForm.vue?vue&type=script&lang=js"

import "./NeobuqCarbonForm.vue?vue&type=style&index=0&id=2d0f6a15&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0f6a15"]])

export default __exports__